import { render, staticRenderFns } from "./reservation-card-modal.vue?vue&type=template&id=945812be&scoped=true&"
import script from "./reservation-card-modal.vue?vue&type=script&lang=js&"
export * from "./reservation-card-modal.vue?vue&type=script&lang=js&"
import style0 from "./reservation-card-modal.vue?vue&type=style&index=0&id=945812be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945812be",
  null
  
)

export default component.exports